import { render, staticRenderFns } from "./banner_mob.vue?vue&type=template&id=077dbb48&scoped=true&"
import script from "./banner_mob.vue?vue&type=script&lang=js&"
export * from "./banner_mob.vue?vue&type=script&lang=js&"
import style0 from "./banner_mob.vue?vue&type=style&index=0&id=077dbb48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077dbb48",
  null
  
)

export default component.exports